export default __webpack_public_path__ + "images/RT.50c4555.png";